import { create } from 'zustand'

const initState = {
  validations: null,
  registryValidations: null,
  sitesValidations: null,
  resultsTableValidations: null,
}

const useAuthoringValidationsStore = create((set) => ({
  ...initState,
  setValidations: (validations) => set({ validations }),
  setRegistryValidations: (registryValidations) => set({ registryValidations }),
  setSitesValidations: (sitesValidations) => set({ sitesValidations }),
  setResultsTableValidations: (resultsTableValidations) => set({ resultsTableValidations }),
  resetAuthoringValidationsStore: () => set(initState),
}))

export default useAuthoringValidationsStore;